export default {
  $schema: 'http://json-schema.org/draft-04/schema#',
  type: 'object',
  properties: {
    id: {
      $rel: 'listing',
      type: 'integer',
    },
    offer_to: {
      type: 'string',
    },
  },
}
